import { render, staticRenderFns } from "./addOne.vue?vue&type=template&id=74ea70bb&scoped=true&"
import script from "./addOne.vue?vue&type=script&lang=js&"
export * from "./addOne.vue?vue&type=script&lang=js&"
import style0 from "./addOne.vue?vue&type=style&index=0&id=74ea70bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea70bb",
  null
  
)

export default component.exports